import React from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
import Heading from '../../Heading';

class Page1 extends React.PureComponent {
  componentDidMount() {
    if (window.pageYOffset > this.sectionRef.offsetTop) {
      window.scrollTo({ top: this.sectionRef.offsetTop, behavior: 'smooth' });
    }
  }

  render() {
    return (
      <fieldset className="justifycentre page-1 images-container" ref={(sectionRef) => { this.sectionRef = sectionRef; }}>
        <Paragraph classes="images" center>
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/quitsmoking-roundal.png" alt="" width="100" height="100" />
        </Paragraph>
        <Heading classes="header-text smallest purple" center><span id="register1">You&apos;re one step closer to breaking those habits!</span></Heading>
        <Paragraph center><strong>LiveWell Dorset is a free service to help you make healthy lifestyle changes. We help people to stop smoking, cut down on alcohol, get more active and achieve a healthy weight.</strong></Paragraph>
        <Paragraph center>
          We’ll connect you with one of our Wellness Coaches to support you to give up smoking. Your Coach will work with you to plan what changes you’ll need to make to support a smoke-free life, help you identify any obstacles you might be facing and support you to work out how you’ll overcome them.
        </Paragraph>
        <Paragraph classes="button-groups" center>
          <Button classes={['color-button']} label="Register" onClick={this.props.onSubmit} />
        </Paragraph>
      </fieldset>
    );
  }
}

Page1.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'registrationPilot', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(Page1);



// WEBPACK FOOTER //
// ./src/Components/PilotRegister/FormPages/Page1.jsx